import api from './axios';

export const login = (credentials) => api.post('/users/login/', credentials);
export const register = (data) => api.post('/users/register/', data);
export const getProfile = () => api.get('/users/profile/');
export const updateProfile = (data) => api.patch('/users/profile/', data);
